export const generateRandomString = (length: number = 15): string => {
  return Math.random()
    .toString(36)
    .substring(2, 2 + length);
};

export const generateOAuthState = (provider: string): string => {
  return `${generateRandomString(15)}|${provider}`;
};
